module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_niconico.83c888764d0951ff5ff310a54b9b4ceb.png";